<template>
  <div class="px-3 py-4 pc:pt-[80px] bg-osn-yellow-07 flex justify-center">
    <div class="w-full max-w-[1440px] flex justify-center">
      <div class="w-full p-4 mb-4 pc:min-w-[700px] bg-osn-white-00 rounded-md">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup
        lang="ts">

</script>

<style scoped
       lang="scss">

</style>
